import type {UseQueryOptions} from '@tanstack/react-query'
import {queryOptions, useSuspenseQuery} from '@tanstack/react-query'

import type {Thread} from '@/models/threadModel'
import {getThreads} from '@/services/threadService'

export function getThreadsQueryKey() {
  return ['threads'] as const
}

function getThreadsQueryOptions<TData = Thread[], TError = Error>(
  options?: Omit<UseQueryOptions<Thread[], TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getThreadsQueryKey(),
    queryFn: async ({signal}) => getThreads({signal}),
    ...options,
  })
}

export default function useThreadsSuspense<TData = Thread[], TError = Error>(
  options?: Omit<UseQueryOptions<Thread[], TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return useSuspenseQuery(getThreadsQueryOptions<TData, TError>(options))
}
